import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { mappingsStates } from '../../hooks/useMappingsHook';

const mappingsActions = mapDefaultValuesToActions(mappingsStates);

export default reduxReducerHelper(mappingsActions, mappingsStates);
